<script>
  const trio = [
    {
      icon: 'running',
      text: 'Fast'
    },
    {
      icon: 'brain',
      text: 'Intelligent'
    },
    {
      icon: 'arms-up',
      text: 'Tailor-made'
    }
  ]
</script>

<svelte:head>
  <link rel="canonical" href="https://squid.software/" />
</svelte:head>

<div class="main">
  <h1 class="tagline">Intelligent software<br />for logistics</h1>
  <div class="trio">
    {#each trio as item}
      <div class="item">
        <img src={`/icons/${item.icon}-large.png`} alt={`${item.icon} icon`} class="icon" />
        <p>{item.text}</p>
      </div>
    {/each}
  </div>
  <div class="info">
    <p>Blazing fast and intelligent software that fits your organisation like a suit.</p>
    <p>Your planners will love it!</p>
  </div>
  <h2 class="about">About me</h2>
  <div class="profile">
    <img src="/chris.png" alt="chris" class="chris" />
    <p class="description">
      Hi, my name is Christian.<br /><br />
      I'm an independent software developer with 10+ years of experience in IT. I spent many of those
      years researching and writing logistics planning algorithms.<br /><br />
      Squid is my vehicle to make that knowledge available to you!
    </p>
  </div>
</div>

<style>
  .tagline {
    font-size: 4em;
    font-weight: 500;
  }
  .trio {
    margin-top: 80px;
    display: flex;
    flex-wrap: wrap;
  }
  .item {
    flex-grow: 1;
    flex-basis: 33%;
    font-size: 2em;
    margin-top: 50px;
    margin-bottom: 10px;
    min-width: 200px;
  }
  .item p {
    padding-left: 50px;
    padding-right: 50px;
  }
  .item img {
    max-width: 90px;
  }
  .info {
    font-size: 1.5em;
    font-style: italic;
    margin: 0 10% 0 10%;
  }
  .info p {
    margin-top: 0;
    margin-bottom: 0;
  }
  .info p + p {
    margin-top: 15px;
    padding-bottom: 24px;
  }
  .profile {
    display: flex;
    margin: 0 10% 0 10%;
    align-items: center;
    justify-content: center;
  }
  .chris {
    min-width: 200px;
    min-height: 200px;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    overflow: hidden;
    border: 3px solid var(--primary-color);
  }
  .description {
    font-size: 1.5em;
    padding-left: 50px;
    max-width: 600px;
    text-align: left;
  }
  .about {
    margin-top: 100px;
  }
  @media (max-width: 600px) {
    .tagline {
      font-size: 2em;
    }
    .trio {
      margin-top: 0;
      flex-direction: column;
      align-content: center;
    }
    .profile {
      flex-direction: column;
    }
    .item {
      display: flex;
      align-items: center;
      padding-bottom: 0;
      margin-bottom: 0;
      font-size: 1.5em;
    }
    .item:last-of-type {
      margin-bottom: 30px;
    }
    .item p {
      padding-left: 25px;
      padding-right: 25px;
    }
    .about {
      margin-top: 50px;
    }
    .description {
      padding-left: 0;
      text-align: center;
      font-size: 1.3em;
    }
  }
</style>
